import { Routes } from '@angular/router';
import { AuthGuardFn, LoginGuardFn } from '@core';

export const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('./modules/layout/layout.routes').then(layout => layout.layoutRoutes),
		canActivate: [AuthGuardFn]
	},
	{
		path: 'login',
		loadChildren: () => import('./login/login.routes').then(login => login.loginRoutes),
		canActivate: [LoginGuardFn]
	},
	{
		path: 'catalogues',
		loadChildren: () => import('./catalogue/catalogue.routes').then(catalogue => catalogue.catalogueRoutes),
		data: { title: 'Catalogue' }
	},
	{
		path: 'auth',
		loadChildren: () => import('./modules/pages').then(authenticate => authenticate.authenticateRoutes)
	},
	{
		path: 'page-not-found',
		loadChildren: () => import('./page-not-found/page-not-found.routes').then(m => m.notFoundRoutes),
		data: { title: 'Page Not Found' }
	},
	{
		path: 'app-reports',
		loadChildren: () => import('./modules/pages').then(m => m.appReportsRoutes),
		data: { title: 'Order Reports' }
	},
	{
		path: 'stats-reports',
		loadChildren: () => import('./modules/pages').then(m => m.statsReportsRoute),
		data: { title: 'Stats Reports' }
	},
	{
		path: 'payments',
		loadChildren: () => import('./modules/pages').then(m => m.paymentsRoutes),
		data: { title: 'Payment' }
	},
	{
		path: 'meeting-invite',
		loadChildren: () => import('./modules/pages').then(m => m.rsvpRoutes),
		data: { title: 'Invitation' }
	},
	{
		path: 'sales-target-reports',
		loadChildren: () => import('./modules/pages').then(m => m.salesRoutes),
		data: { title: 'Sales Target Reports' }
	},
	// { path: '**', redirectTo: 'login', pathMatch: 'full' },
	{
		path: ':appId/catalogues',
		loadChildren: () => import('./catalogue/catalogue.routes').then(catalogue => catalogue.catalogueRoutes),
		data: { title: 'Catalogue' }
	},
	{
		path: '**',
		loadChildren: () => import('./page-not-found/page-not-found.routes').then(m => m.notFoundRoutes),
		data: { title: 'Page Not Found' }
	}
]
